import { render, staticRenderFns } from "./GraphTransactions.vue?vue&type=template&id=532d2882&lang=html&"
import script from "./GraphTransactions.vue?vue&type=script&lang=js&"
export * from "./GraphTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('532d2882')) {
      api.createRecord('532d2882', component.options)
    } else {
      api.reload('532d2882', component.options)
    }
    module.hot.accept("./GraphTransactions.vue?vue&type=template&id=532d2882&lang=html&", function () {
      api.rerender('532d2882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/statistics/components/GraphTransactions.vue"
export default component.exports